// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7ad2f92c","732":"b41712b3","977":"14c1afac"}[chunkId] + ".chunk.js";
};